<template>
  <div class="search-bar">
    <div class="search-input-wrapper">
      <i class="fas fa-search search-icon"></i>
      <input
        type="text"
        class="search-input"
        :placeholder="placeholder"
        ref="searchInput"
        :value="modelValue"
        @input="onInput($event)"
        @keyup.enter="onEnter($event)"
      />
      <button
        v-if="modelValue"
        class="clear-button"
        @click="clear"
        title="Clear search"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchBar",
  props: {
    placeholder: {
      type: String,
      default: "Search...",
    },
    modelValue: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue", "search", "input"],
  methods: {
    onInput(e) {
      const v = e.target.value;
      this.$emit("update:modelValue", v);
      this.$emit("search", v);
    },
    onEnter(e) {
      const v = e.target.value;
      this.$emit("search", v);
    },
    clear() {
      this.$emit("update:modelValue", "");
      this.$emit("search", "");
      // focus back to input
      this.$nextTick(() => {
        if (this.$refs.searchInput) {
          this.$refs.searchInput.focus();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-bar {
  width: 100%;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background: var(--oliver-bg);
  border: 2px solid var(--oliver-input-border, rgba(0, 0, 0, 0.15));
  border-radius: 12px;
  padding: 8px 16px;
  transition: all 0.2s ease;

  &:focus-within {
    border-color: var(--oliver-input-focus-border);
  }
}

.search-icon {
  color: var(--oliver-text-muted);
  cursor: pointer;
  font-size: 15px;
  margin-right: 12px;
  flex-shrink: 0;
}

.search-input {
  flex: 1;
  width: 100%;
  padding-right: 8px;
  border: none;
  outline: none;
  font-size: 14px;
  color: var(--oliver-text);
  background: transparent;
  font-family: inherit;

  &::placeholder {
    color: var(--oliver-text-muted);
  }
}

.clear-button {
  position: absolute;
  right: 6px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: none;
  border: 0;
  color: var(--oliver-text-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    color: var(--oliver-text);
  }

  i {
    font-size: 15px;
  }
}

@media (max-width: 768px) {
  .search-input-wrapper {
    padding: 14px 18px;
  }

  .search-icon {
    font-size: 18px;
    margin-right: 14px;
  }

  .search-input {
    font-size: 16px;
  }

  .clear-button {
    width: 32px;
    height: 32px;

    i {
      font-size: 14px;
    }
  }
}
</style>
